export default __webpack_public_path__ + "static/media/comparison-nova.99978db7.jpg";